module.exports = __webpack_public_path__ + "img/pannonia.bffdfe68.png";